
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/regulatory-changes/enacted-law-bulletin",
      function () {
        return require("private-next-pages/compliance/regulatory-changes/enacted-law-bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/regulatory-changes/enacted-law-bulletin"])
      });
    }
  